import script from "./AccountIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountIcon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__